import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const OfficeAssetOrgLayout = () => {
  const navList = useNav();
  let { officeAssetsOrgBottom, officeAssetsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={officeAssetsOrgBottom} topTabs={officeAssetsTopHeader} />
      <Outlet />
    </div>
  )
}

export default OfficeAssetOrgLayout